import { LitEntity, html } from '../utility/lit-entity';
import { StoreMixin } from '../utility/store-mixin';
import { IndexMixin } from '../utility/index-mixin';
import { SirenActionMixin } from '../utility/siren-action-mixin';
import '../common/bn-dynamically-imported';
import './device-dashboard';
import './device-show';

class DeviceIndex extends IndexMixin(StoreMixin(SirenActionMixin(LitEntity))) {
  static get properties() {
    return {
      selectedDeviceHref: { type: String, attribute: false },
      serialNumber: { type: String, attribute: false },
    };
  }

  getViews() {
    return [
      {
        default: true,
        name: 'list',
        render: () => {
          return html`
            <device-dashboard .href="${this.href}" .path="${this.tail}"></device-dashboard>
          `;
        },
      },
      {
        name: 'show',
        render: () => {
          return html`
            <device-show .href="${this.selectedDeviceHref}"   .path="${this.tail}"></device-show>
          `;
        },
      },
    ];
  }

  _stateChanged({ query }) {
    if (!query) {
      return;
    }

    if (query.deviceId) {
      this.selectedDeviceHref = query.deviceId;
      this.serialNumber = undefined;
      return;
    }

    if (this.serialNumber !== query.serialNumber) {
      this.selectedDeviceHref = undefined;
      this.serialNumber = query.serialNumber;
      this.fetchDeviceHrefFromSerialNumber(this.serialNumber);
    }
  }

  async fetchDeviceHrefFromSerialNumber(serialNumber) {
    if (!serialNumber) {
      return;
    }
    const config = JSON.parse(import.meta.env.VITE_PROJECT_AWS_SSM_CONFIG);
    const apiRootHref = config['api-root'];

    const apiRoot = await this.fetchSiren(apiRootHref, false);
    const devicesEntity = await this.fetchSiren(apiRoot.getLink('https://api.binsentry.com/rel/devices').href, false);

    const action = devicesEntity.getAction('find-device-by-serial-number');
    if (!action) {
      return;
    }
    const fields = this.getActionFields(action);
    fields.set('serialNumber', this.serialNumber);

    const deviceEntity = await this.fetchSiren(this.parseAction(action, fields).url.href, false);
    if (deviceEntity && this.serialNumber === serialNumber) {
      this.selectedDeviceHref = deviceEntity.getLink('self').href;
    }
  }
}

window.customElements.define('device-index', DeviceIndex);
